import React, { useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import styled, { css } from 'styled-components';
import {
  BaseBox,
} from '@docon/docon-ui-library';
import Login from 'components/Login';
import VerifyOtp from 'components/Login/VerifyOtp';
import { RouteComponentProps, withRouter } from 'react-router';

export type IProps = RouteComponentProps;
const Root = styled(BaseBox)`
  width: 100%;

  .loginForm {
    padding: 1.5rem 0;
    button {
      margin-top: 16px;
    }
  }

  ${() => isMobileOnly && css`
    padding: 1rem 0;
  `}
`;

function BookingLogin({
  ...props
}: IProps) {

  const [mobileNumber, setMobileNumber] = useState('');
  function handleLoginSuccess(mobileNumber: any) {
    setMobileNumber(mobileNumber);
  }

  function handleNumberChange() {
    setMobileNumber('');
  }

  return (
    <Root>
      {
        mobileNumber ? (
          <VerifyOtp
            onlyForm
            formClassName={'verifyOtpForm'}
            mobile={mobileNumber}
            onNumberChange={handleNumberChange}
            {...props}
          />

        ) : (
          <Login
            onlyForm
            hideInfoText
            formClassName={'loginForm'}
            onLoginSuccess={handleLoginSuccess}
            {...props}
          />
        )
      }
    </Root>
  );
}

export default styled(withRouter(BookingLogin))``;